import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    display: 'block',
    width: 'auto',
    height: 50,
    margin: 'auto',
  },
  path: {
    fill: '#7df3e1',
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    <img src="/logo.png" className={classes.svg}/>
  );
};

export default LogoFull;

